/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 2/11/13
 * Time: 5:56 PM
 * To change this template use File | Settings | File Templates.
 */

define(function () {
    "use strict";

    function init(basePath) {
        if (!basePath) {
            basePath = "./";
        } else {
            if (basePath.lastIndexOf("/") !== basePath.length - 1) {
                basePath += "/";
            }
        }
        return {
            paths: {
                // Libraries
                // ---------
                "marionette.componentManager": basePath + "src/marionette.componentManager",
                "componentManager": basePath + "src/componentManager",
                "marionette.gridView": basePath + "src/plugins/gridView/marionette.gridView",
                "marionette.graphQLGridView": basePath + "src/plugins/gridView/marionette.graphQLGridView",
                "ui": basePath + "src/widgets",
                "ui.plugins": basePath + "src/plugins",
                "richTextEditor": basePath + "src/plugins/rich-text-editor/js/RichTextEditor"

            }
        };

    }

    return init;
});
